import { action } from 'typesafe-actions';
import { PageFilterTypes } from './types';

export const pageFiltersUpdate = (page: string, data: any) =>
  action(PageFilterTypes.FILTERS_UPDATE, { page, data });
